// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2iB3E","search":"Settings_search__1LAHH","filter":"Settings_filter__3CHYw"};